import { InitialGeneralState } from 'interfaces/general.interface';

const initialGeneralState: InitialGeneralState = {
  ping: true,
  setPing: () => {},
  isLoadingSetPing: true,
  exchanges: [],
  countries: [],
  associationStates: null,
  isLoadingPointsOfSaleCategories: false,
  pointsOfSaleCategories: [],
};

export default initialGeneralState;
